import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SaveDraftRPC } from "./saveDraftRPC";

export class SaveDraftRPCClientImpl extends SaveDraftRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SaveDraftRPC.Request): Promise<LeoRPCResult<SaveDraftRPC.Response, SaveDraftRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/SaveDraft",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SaveDraftRPC.ResponseDTO,
      SaveDraftRPC.Errors.ErrorsDTO,
      SaveDraftRPC.Response,
      SaveDraftRPC.Errors.Errors
    >(
      response,
      "survey-respondent/SaveDraft",
      SaveDraftRPC.Response.fromDTO,
      SaveDraftRPC.Errors.fromDTO
    );
  }
}
